import { isNewerThan } from '../../../../monitoring/messages/triage/aiTriageState.ts';
import { isPending, type DisplayMessage } from '../composer/pendingMessages.ts';

// Matches the backend's automated sender; today those posts go to the internal chat, not DM.
export const ODO_AUTOMATION_SENDER_NAME = 'ODO Automations';

// 'system' is DM's own service user, so its automated messages never count either.
function isHumanPracticeMessage(message: DisplayMessage): boolean {
    return message.sender === 'practice' && message.senderName !== ODO_AUTOMATION_SENDER_NAME;
}

function newestDelivered(messages: DisplayMessage[]): DisplayMessage | null {
    return messages.reduce<DisplayMessage | null>((newest, message) => {
        if (isPending(message)) return newest;
        if (newest && isNewerThan(newest.createdAt, message.createdAt)) return newest;
        return message;
    }, null);
}

// True when a person on our side sent the newest delivered message, in ODO or in DM itself.
export function isAnsweredByUs(messages: DisplayMessage[]): boolean {
    const newest = newestDelivered(messages);
    return newest !== null && isHumanPracticeMessage(newest);
}
